<template>
  <div class="receive">
    <van-popup v-model="showReceiveDialog" class="receive-popup" :class="[showSeriesDialog ? 'receive-top' : '']">
      <div class="receive-wrap">
        <Border class="receive-alert">
          <img slot="title" class="content-title" src="~@this/assets/title4.png" alt="" />
          <div class="receive-container" slot="content">
            <div
              class="receive-select"
              @click="changeShowSeriesDialog"
              :class="[seriesList.length > 1 ? 'select-bg' : '']"
            >
              {{ series.name }}
            </div>
            <van-checkbox
              checked-color="#1b5af1"
              :label-disabled="true"
              icon-size="1em"
              v-model="isCheck"
              shape="square"
              v-if="showAgreement"
            >
              <span @click="gotoAgreement">我已阅读并同意隐私政策</span>
            </van-checkbox>
            <button type="button" name="button" class="receive-btn" @click="clickReceive"></button>
          </div>
        </Border>
      </div>
      <div @click="close" class="popup-close"></div>
    </van-popup>
    <van-popup v-model="showSeriesDialog" :overlay="false" class="popup" position="bottom">
      <van-picker
        show-toolbar
        cancel-button-text="取消"
        @confirm="clickReceive"
        @cancel="changeShowSeriesDialog"
        defaultIndex="0"
        :columns="seriesList"
        value-key="name"
        @change="selectSeries"
      />
    </van-popup>
  </div>
</template>

<script>
import { Popup, Checkbox, Picker } from 'vant';
import Border from './Border.vue';
export default {
  data() {
    return {
      showReceiveDialog: false,
      showSeriesDialog: false,
    };
  },
  props: {
    showReceive: {
      type: Boolean,
      default: false,
    },
    showSeries: {
      type: Boolean,
      default: false,
    },
    seriesList: {
      type: Array,
      default() {
        return [];
      },
    },
    series: {
      type: Object,
      default() {
        return {};
      },
    },
    showAgreement: {
      type: Boolean,
      default: true,
    },
    agreementCheckbox: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    showReceive(val) {
      this.showReceiveDialog = val;
    },
    showSeries(val) {
      this.showSeriesDialog = val;
    },
  },
  computed: {
    isCheck: {
      get() {
        return this.agreementCheckbox;
      },
      set(val) {
        this.$emit('update:agreementCheckbox', val);
      },
    },
  },
  methods: {
    clickReceive() {
      this.$emit('clickReceive');
    },
    gotoAgreement() {
      this.$emit('gotoAgreement');
    },
    selectSeries(vm, item) {
      this.$emit('selectSeries', item);
    },
    close() {
      this.$emit('changeShowReceiveDialog', false);
      this.$emit('changeShowSeriesDialog', false);
    },
    changeShowSeriesDialog() {
      this.$emit('changeShowSeriesDialog');
    },
    changeShowReceiveDialog() {
      this.$emit('changeShowReceiveDialog');
    },
  },
  components: {
    [Popup.name]: Popup,
    [Checkbox.name]: Checkbox,
    [Picker.name]: Picker,
    Border,
  },
};
</script>
<style lang="scss" scoped>
.receive {
  $receiveBg: linear-gradient(#ffffff, #c9e9c5);
  $receiveSelectBg: #ffffff;
  $receiveSelectFontColor: #000000;
  $receiveBtnBg: url(~@this/assets/receive-btn.png) center/contain no-repeat;
  $receiveTitleFontColor: #5bbb4f;
  &-alert ::v-deep {
    .border {
      height: 125px;
    }
  }
  .popup-close {
    width: 100px;
    height: 100px;
  }
  &-popup ::v-deep {
    .van-checkbox {
      width: 500px;
      height: 70px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      color: #ffffff;
      &__label {
        font-size: 30px;
        margin-left: 10px;
        text-align: left;
      }
    }
  }
  &-top {
    top: 30%;
  }
  &-btn {
    width: 375px;
    height: 93px;
    border: 0;
    margin: 20px auto 0;
    background: $receiveBtnBg;
    display: block;
  }
  &-wrap {
    width: 650px;
    position: relative;
  }
  &-title {
    height: 122px;
    line-height: 122px;
    width: 100%;
    font-size: 34px;
    font-weight: bold;
    color: $receiveTitleFontColor;
  }
  &-container {
    padding-top: 20px;
  }
  &-select {
    width: 560px;
    height: 117px;
    line-height: 117px;
    border-radius: 10px;
    padding-left: 50px;
    box-sizing: border-box;
    margin: 0 auto;
    font-size: 30px;
    text-align: left;
    position: relative;
    background: $receiveSelectBg;
    color: $receiveSelectFontColor;
    &.select-bg {
      background-size: 40px 40px;
    }
    &::before {
      content: '';
      position: absolute;
      right: 28px;
      top: 50px;
      width: 0;
      height: 0;
      z-index: 1;
      border-left: 20px solid transparent;
      border-right: 20px solid transparent;
      border-top: 20px solid #000000;
    }
  }
}
</style>
